import { render, staticRenderFns } from "./AccordionVATIncreaseNotify.vue?vue&type=template&id=46003f72&scoped=true"
import script from "./AccordionVATIncreaseNotify.vue?vue&type=script&lang=js"
export * from "./AccordionVATIncreaseNotify.vue?vue&type=script&lang=js"
import style0 from "./AccordionVATIncreaseNotify.vue?vue&type=style&index=0&id=46003f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46003f72",
  null
  
)

export default component.exports